import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getAutoApproveSettings,
  updateAutoApproveSetting,
  type AutoApproveKey,
  type AutoApproveSettings,
} from '../api/plan-override-settings-api'

export const AUTO_APPROVE_SETTINGS_QUERY_KEY = 'auto-approve-settings'

export function useGetAutoApproveSettings() {
  return useQuery({
    queryKey: [AUTO_APPROVE_SETTINGS_QUERY_KEY],
    queryFn: getAutoApproveSettings,
    staleTime: 30_000,
  })
}

export function useToggleAutoApprove(key: AutoApproveKey) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (checked: boolean) => updateAutoApproveSetting(key, checked),
    onSuccess: (_data, checked) => {
      queryClient.setQueryData<AutoApproveSettings>(
        [AUTO_APPROVE_SETTINGS_QUERY_KEY],
        (prev) => (prev ? { ...prev, [key]: checked } : prev)
      )
    },
  })
}
